<template>
  <div>
    <vs-card id="vendor-table-loading" class="vs-con-loading__container">
      <vs-row>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <VendorTable
            :data="data"
            @search="search"
            @loadMore="loadMore"
            @showDetails="showDetails"
            @lock="lock"
          />
        </vs-col>
      </vs-row>
    </vs-card>
  </div>
</template>

<script>
import VendorTable from './components/VendorTable.vue'
import request from './request'
import loading from '@/mixins/Loading'
export default {
  components: {
    VendorTable,
  },
  data() {
    return {
      data: [],
      params: {
        lastPage: 1,
        page: 1,
        search: '',
        sortBy: ['Vendors.VendorName'],
        sort: ['ASC'],
      },
    }
  },
  mixins: [loading],
  methods: {
    getVendors() {
      this.openLoading('vendor-table-loading')
      let payload = { ...this.params }
      if (payload.search == '') {
        delete payload.search
      }
      request
        .getVendors(payload)
        .then((response) => {
          this.params.lastPage = response.data.vendors.last_page
          this.params.page = response.data.vendors.current_page
          let data = response.data.vendors.data
          data.map((obj) => {
            obj.lock = obj.lock === '1' ? 1 : 0
            return obj
          })
          if (this.params.page === 1) {
            this.data = [...data]
          } else {
            this.data = [...this.data, ...data]
          }
          this.closeLoading('vendor-table-loading')
        })
        .catch((response) => {
          this.closeLoading('vendor-table-loading')
          this.showValidationErrors(response)
        })
    },
    loadMore() {
      if (this.params.page >= this.params.lastPage) {
        return
      }
      this.params.page++
      this.getVendors()
    },
    search(event = '') {
      this.params.search = event
      this.params.page = 1
      this.getVendors()
    },
    showDetails(id) {
      this.$router.push({
        name: 'vendors-detail',
        params: {
          id: id,
        },
      })
    },
    lock(item){
      this.openLoading('vendor-table-loading')
      const payload = {
        id:item.id,
        lock:item.lock
      }
      request
        .lock(payload)
        .then((response) => {
          this.closeLoading('vendor-table-loading')
          this.$vs.notify({
            color: 'success',
            title: 'Success',
            text: 'Vendor Updated',
          })
        })
        .catch((response) => {
          this.showValidationErrors(response)
          this.closeLoading('vendor-table-loading')
        })
    }
  },
  mounted() {
    this.getVendors()
  },
  watch: {
    isLoading(val) {
      if (val) {
        this.openLoading('vendor-table-loading')
      } else {
        this.closeLoading('vendor-table-loading')
      }
    },
  },
}
</script>

<style>
</style>